// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator-paginator-311a","dot":"Paginator-dot-311a","d0":"Paginator-d0-311a","d1":"Paginator-d1-311a","d2":"Paginator-d2-311a","d3":"Paginator-d3-311a"};